import { render } from "./YoutubeAuth.vue?vue&type=template&id=3b5ab014&ts=true"
import script from "./YoutubeAuth.vue?vue&type=script&lang=ts"
export * from "./YoutubeAuth.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__